module.exports = __webpack_public_path__ + "img/ic-facebook.11c728c0.svg";